import { render, staticRenderFns } from "./TestDataUploader.vue?vue&type=template&id=a3bc3d6e&scoped=true"
import script from "./TestDataUploader.vue?vue&type=script&lang=js"
export * from "./TestDataUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3bc3d6e",
  null
  
)

export default component.exports